/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Whether the whole offer can be refunded before the departure of the first slice.
 * If all of the slices on the offer can be refunded then the `allowed` property will be `true` and information will be provided about any penalties.
 * If any of the slices on the offer can't be refunded then the `allowed` property will be `false`.
 * If the airline hasn't provided any information about whether this offer can be refunded then this property will be `null`.
 * 
 * @export
 * @interface OfferConditionsRefundBeforeDeparture
 */
export interface OfferConditionsRefundBeforeDeparture {
    /**
     * Whether this kind of modification is allowed post-booking
     * @type {boolean}
     * @memberof OfferConditionsRefundBeforeDeparture
     */
    allowed?: boolean;
    /**
     * If the modification is `allowed` then this is the amount payable to apply the modification to all passengers. If there is no penalty, the value will be zero.
     * If the modification isn't `allowed` or the penalty is not known then this field will be `null`.
     * If this is `null` then the `penalty_currency` will also be `null`.
     * 
     * @type {string}
     * @memberof OfferConditionsRefundBeforeDeparture
     */
    penaltyAmount?: string | null;
    /**
     * The currency of the `penalty_amount` as an [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code.
     * This will be in a currency determined by the airline, which is not necessarily the same as the currency of the offer or order.
     * If this is `null` then `penalty_amount` will also be `null`.
     * 
     * @type {string}
     * @memberof OfferConditionsRefundBeforeDeparture
     */
    penaltyCurrency?: string | null;
}

/**
 * Check if a given object implements the OfferConditionsRefundBeforeDeparture interface.
 */
export function instanceOfOfferConditionsRefundBeforeDeparture(value: object): value is OfferConditionsRefundBeforeDeparture {
    return true;
}

export function OfferConditionsRefundBeforeDepartureFromJSON(json: any): OfferConditionsRefundBeforeDeparture {
    return OfferConditionsRefundBeforeDepartureFromJSONTyped(json, false);
}

export function OfferConditionsRefundBeforeDepartureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferConditionsRefundBeforeDeparture {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
        'penaltyAmount': json['penalty_amount'] == null ? undefined : json['penalty_amount'],
        'penaltyCurrency': json['penalty_currency'] == null ? undefined : json['penalty_currency'],
    };
}

export function OfferConditionsRefundBeforeDepartureToJSON(json: any): OfferConditionsRefundBeforeDeparture {
    return OfferConditionsRefundBeforeDepartureToJSONTyped(json, false);
}

export function OfferConditionsRefundBeforeDepartureToJSONTyped(value?: OfferConditionsRefundBeforeDeparture | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'penalty_amount': value['penaltyAmount'],
        'penalty_currency': value['penaltyCurrency'],
    };
}

